import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.8335 4.16666C10.8335 3.70642 10.4604 3.33333 10.0002 3.33333C9.53993 3.33333 9.16683 3.70642 9.16683 4.16666V13.8215L4.75609 9.41074C4.43065 9.0853 3.90301 9.0853 3.57757 9.41074C3.25214 9.73618 3.25214 10.2638 3.57757 10.5893L9.41091 16.4226C9.73634 16.748 10.264 16.748 10.5894 16.4226L16.4228 10.5893C16.7482 10.2638 16.7482 9.73618 16.4228 9.41074C16.0973 9.0853 15.5697 9.0853 15.2442 9.41074L10.8335 13.8215V4.16666Z",
		fill: "currentColor"
	})
});
export default SvgDownArrow;
